import React from 'react';
import TagFilter from '@/components/filters/TagFilter/TagFilter';

interface SupportedNameFilterProps {
  selectedSupportedName: string | null;
  setSelectedSupportedName: (supportedName: string | null) => void;
}

const SupportedNameFilter: React.FC<SupportedNameFilterProps> = ({ selectedSupportedName, setSelectedSupportedName }) => {
  if (!selectedSupportedName) {
    return null;
  }

  return <TagFilter variant="status-filter-style" title={selectedSupportedName} onClose={() => setSelectedSupportedName(null)} />;
};

export default SupportedNameFilter;
